import PlayPcrenderModal from "./play-pcrender-modal.component";

export default PlayPcrenderModal;
